import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { getStorage, ref, getDownloadURL } from 'firebase/storage';

const fetchDownloadURL = async (storageLink: string) => {
  if (!storageLink) throw new Error('Storage link is required');

  const storage = getStorage();
  return getDownloadURL(ref(storage, storageLink));
};
export const firebaseApi = createApi({
  reducerPath: 'firebaseApi',
  baseQuery: fetchBaseQuery(),
  endpoints: (builder) => ({
    getDownloadURL: builder.query({
      queryFn: async (storageLink: string) => {
        const url = await fetchDownloadURL(storageLink);
        return { data: url };
      },
      keepUnusedDataFor: 600,
    }),
  }),
});

export const {
  useGetDownloadURLQuery: useGetDownloadURL,
  useLazyGetDownloadURLQuery: useLazyGetDownloadURL,
} = firebaseApi;
